import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconFioriError = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12 6.5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
        fill: 'currentColor',
      }),
    ],
  });
IconFioriError.displayName = 'IconFioriError';
